import Global from "../common/global";
import { MapHelper } from '../common/mapHelper';
import { SortingHelper } from '../common/sortingHelper';
import { FilterHelper } from '../common/filterHelper';
import { BottomSheet } from '../common/bottomSheet';
import { initCalendar } from '../common/calendar';
import { initSearchBarFields, initSearchOptionClick, initMobileSearchbarToggle, initSearchDropdownHandler } from '../common/searchBarFields';
import { SearchRoomManager } from '../common/searchRoomManager';

// Create an instance of BottomSheet with the required element IDs
const bottomSheet = new BottomSheet('sheet', 'sheetHandle', 'sheetBody');

// Initialize the bottom sheet instance
bottomSheet.init();

// Initialize the map (from your external helper)
MapHelper.initMainMap('mainMap');

// Handle clicks on hotel images and hotel names
document.addEventListener("DOMContentLoaded", () => {
    Global.hideOverflowMobile();

    initCalendar(false);

    // Initialize the search bar fields and sheets/dropdowns
    initSearchBarFields({ desktopBreakpoint: 992 });
    initSearchDropdownHandler();

    // Initialize search-option click handling
    initSearchOptionClick();

    const roomsEl = document.querySelector('#rooms');
    if (roomsEl) {
        // Example max rooms
        const maxRooms = 5;

        // Create instance
        const searchRoomManager = new SearchRoomManager(maxRooms);

        // Initialise event handlers
        searchRoomManager.init();
    }

    initMobileSearchbarToggle();

    // Filters / Sorting
    SortingHelper.initSorting();
    FilterHelper.initFilters();

    document.querySelectorAll<HTMLElement>(".hotel-list-card").forEach((card) => {
        const hotelUrl = card.dataset.hotelUrl;
        if (!hotelUrl) return;

        // Click to link to hotel page
        card.querySelectorAll<HTMLImageElement>(".link-to-hotel").forEach((link) => {
            link.addEventListener("click", (e) => {
                e.stopPropagation();

                if (window.innerWidth > 992) {
                    e.preventDefault();
                    window.open(hotelUrl, "_blank");
                } else {
                    window.location.href = hotelUrl;
                }
            });
        });

        // Hover events for the entire card
        card.addEventListener("mouseenter", () => {
            const hotelId = card.dataset.hotelId;
            
            if (!hotelId) return;
            MapHelper.highlightMarker(hotelId);
        });

        card.addEventListener("mouseleave", () => {
            const hotelId = card.dataset.hotelId;
            if (!hotelId) return;
            MapHelper.unhighlightMarker(hotelId);
        });
    });
});